import { DISABLED_OPACITY } from "../../../../../../../../styles/colors/consts";
import useForegroundVariantColor from "../../../../../../../../styles/colors/surfaces/useForegroundVariantColor";
import {
  AlignItems,
  BoxSizing,
  Dimension,
  Display
} from "../../../../../../../../types";

export default function useMenuItemStyles(disabled?: boolean) {
  const foregroundVariantColor1 = useForegroundVariantColor("1");
  const foregroundVariantColor2 = useForegroundVariantColor("2");

  return {
    display: "flex" as Display,
    alignItems: "center" as AlignItems,
    height: "40px",
    width: "100%",
    padding: "small" as Dimension,
    background: "none",
    outline: "none",
    border: "none",
    textDecoration: "none",
    color: "unset",
    borderRadius: "small" as Dimension,
    boxSizing: "border-box" as BoxSizing,
    opacity: disabled ? DISABLED_OPACITY : "1",
    cursor: disabled ? "not-allowed" : "pointer",
    hoverStyles: disabled
      ? undefined
      : {
          backgroundColor: foregroundVariantColor1
        },
    activeStyles: disabled
      ? undefined
      : {
          backgroundColor: foregroundVariantColor2
        }
  };
}
